"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _menuMeatball = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/menu-meatball"));

var _tileContext = _interopRequireDefault(require("./tile-context"));

var _clickable = _interopRequireDefault(require("../_clickable"));

var _menu = _interopRequireWildcard(require("../menu"));

var _icon = _interopRequireDefault(require("../icon"));

var _useFocus2 = _interopRequireDefault(require("../_use-focus"));

var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));

var _token = require("./../_utils/token");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var tileActionStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var disabled = _ref.disabled;
  var styles = disabled ? {
    cursor: "not-allowed",
    color: "".concat(t("actionForegroundColorDisabled"), " !important")
  } : {
    "&:hover": {
      backgroundColor: t("actionBackgroundColorHover")
    },
    "&:active": {
      backgroundColor: t("actionBackgroundColorPressed")
    }
  };
  return (0, _emotion.css)(styles);
}, ["disabled"]);
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var accentPosition = _ref2.accentPosition;
  var borderWidth = t("borderWidth");
  var borderColor = t("borderColor");
  var borderRadius = t("borderRadius");
  return (0, _emotion.css)({
    display: "flex",
    borderRadius: accentPosition === "left" ? "0 0 ".concat(borderRadius, "px 0") : "0 0 ".concat(borderRadius, "px ").concat(borderRadius, "px"),
    overflow: "hidden",
    // Unfortunately this specificity hack is necessary to override some of
    // the reset styles applied by Clickable
    "& > *:not(#mdn-specificity-hack)": {
      borderTop: "".concat(borderWidth, "px solid ").concat(borderColor, " !important"),
      flex: 1,
      whiteSpace: "nowrap",
      textAlign: "center",
      height: t("actionHeight"),
      padding: "0 ".concat(t("spacingInset"), "px"),
      color: t("actionForegroundColorDefault"),
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center"
    },
    "& > *:not(:first-child)": (0, _defineProperty2["default"])({
      borderLeft: "".concat(borderWidth, "px solid ").concat(borderColor)
    }, "[dir=\"rtl\"] &", {
      borderLeft: "none",
      borderRight: "".concat(borderWidth, "px solid ").concat(borderColor)
    }),
    "& > [mdn-tile-action-focus]": (0, _focusRing["default"])(t.tokens, {
      focus: true,
      offset: -2,
      borderRadius: borderRadius,
      borderWidth: borderWidth
    })
  });
}, ["accentPosition"]);
/**
 * This renders a single tile action "button" if the `actions` prop is set.
 */

var TileAction = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useContext = (0, _react.useContext)(_tileContext["default"]),
      t = _useContext.t,
      disabled = _useContext.disabled;

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, props, focusProps, {
    className: tileActionStyles(t, {
      disabled: props.disabled || disabled
    }),
    title: props.label,
    ref: ref,
    "mdn-tile-action-focus": focus && focusTrigger === "keyboard" ? "" : undefined
  }));
});

TileAction.displayName = "TileAction";
TileAction.propTypes = process.env.NODE_ENV !== "production" ? {
  label: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  href: _propTypes["default"].string,
  rel: _propTypes["default"].string,
  target: _propTypes["default"].string,
  onClick: _propTypes["default"].func
} : {};
/**
 * This renders a set of action for a tile. Import this and pass it to the
 * `actionBar` prop of the `Tile` component to add actions to the tile.
 */

var TileActionBar = function TileActionBar(props) {
  var _useContext2 = (0, _react.useContext)(_tileContext["default"]),
      t = _useContext2.t,
      accentPosition = _useContext2.accentPosition,
      actionMenuOpen = _useContext2.actionMenuOpen,
      setActionMenuOpen = _useContext2.setActionMenuOpen,
      disabled = _useContext2.disabled; // Split actions into visible & overflow and setup state for an overflow
  // menu


  var overflowMenuRef = (0, _react.useRef)();
  var actions = props.actions,
      maxVisibleActions = props.maxVisibleActions;
  var visibleActions = (0, _react.useMemo)(function () {
    return actions.length > maxVisibleActions ? actions.slice(0, maxVisibleActions - 1) : actions;
  }, [actions, maxVisibleActions]);
  var overflowActions = (0, _react.useMemo)(function () {
    return actions.length > maxVisibleActions ? actions.slice(maxVisibleActions - 1) : [];
  }, [actions, maxVisibleActions]);
  var openOverflowMenu = (0, _react.useCallback)(function () {
    return setActionMenuOpen(true);
  }, [setActionMenuOpen]);
  var closeOverflowMenu = (0, _react.useCallback)(function () {
    return setActionMenuOpen(false);
  }, [setActionMenuOpen]); // Don't double count a click on an action as a click on the tile as a whole
  // unit

  var onClickActionBar = (0, _react.useCallback)(function (event) {
    return event.stopPropagation();
  }, []);
  return (
    /*#__PURE__*/
    // The click handler here is not adding any real functionality (see the
    // onClickActionBar callback above for details) so making the element
    // keyboard accessible is not necessary/helpful.
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    _react["default"].createElement("div", {
      className: styles(t, {
        accentPosition: accentPosition
      }),
      onClick: onClickActionBar
    }, visibleActions.map(function (action) {
      return /*#__PURE__*/_react["default"].createElement(TileAction, (0, _extends2["default"])({
        key: action.label,
        disabled: disabled
      }, action), action.children || action.label);
    }), overflowActions.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(TileAction, {
      ref: overflowMenuRef,
      onClick: openOverflowMenu,
      label: props.overflowMenuLabel,
      disabled: disabled
    }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      tokens: _menuMeatball["default"]
    }, props.overflowMenuLabel)), /*#__PURE__*/_react["default"].createElement(_menu["default"], {
      anchorNode: overflowMenuRef.current,
      open: actionMenuOpen,
      position: "bottom",
      alignment: "right",
      onClose: closeOverflowMenu
    }, overflowActions.map(function (action) {
      return /*#__PURE__*/_react["default"].createElement(_menu.MenuItem, (0, _extends2["default"])({}, action, {
        key: action.label
      }), action.label);
    }))) : null)
  );
};

TileActionBar.displayName = "TileActionBar";
TileActionBar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * An array of actions to show. Each action must be an object containing a
   * a string `label` field. An optional `children` field can be used in
   * addition to the label for more advanced rendering (e.g. rendering an icon
   * in an action).
   *
   * Other fields include `disabled`, `href`, `rel`, `target`, and `onClick`.
   * These props behave exactly like the identically named props on the `Button`
   * component. See the [Button API docs](https://meridian.a2z.com/components/button/?detailsTab=api)
   * for usage details.
   */
  actions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    children: _propTypes["default"].node,
    disabled: _propTypes["default"].bool,
    href: _propTypes["default"].string,
    rel: _propTypes["default"].string,
    target: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  })).isRequired,

  /**
   * This determines the maximum number of actions that will be shown at any
   * given time. Any actions over this limit will be put into an overflow menu
   * shown in the action bar.
   */
  maxVisibleActions: _propTypes["default"].number,

  /**
   * This sets a label on the overflow menu for screen readers. This will also
   * be visible in the UI as a title on the overflow menu button.
   *
   * We recommend including details about the menu's context for improved usability for
   * screenreader users (e.g. when used in calendar include the date and time in this label).
   */
  overflowMenuLabel: _propTypes["default"].string
} : {};
TileActionBar.defaultProps = {
  maxVisibleActions: 3,
  overflowMenuLabel: "More actions"
};
var _default = TileActionBar;
exports["default"] = _default;